import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import ReceitaIcon from "../../assets/icons/receitas.png";

import ReceitasService from "../../services/ReceitasService";


export default function ReceitaForm({
  itemSelecionado,
  modo,
  onClose
}) {
  const { setRetorno } = useGerenciamento();

  const [form, setForm] = useState({
    idReceita: null,
    descricao: "A",
    idOrigem: "",
    valor: "",
    pago: false
  });

  const [origens, setOrigens] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  
  // ==========================
  // LOAD ALTERAR
  // ==========================
  useEffect(() => {
    if (modo === "alterar" && itemSelecionado) {
      setForm({
        ...itemSelecionado,
        pago: Boolean(itemSelecionado.pago)
      });
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  }

  // ==========================
  // VALIDAR
  // ==========================
  function validar() {
    const e = {};
    if (!form.descricao) e.descricao = "Informe descrição";
    if (!form.valor) e.valor = "Informe valor";
    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();
    const validation = validar();
    setErrors(validation);
    if (Object.keys(validation).length) return;

    setLoading(true);

    try {
      if (modo === "novo") {
        await ReceitasService.create({
          DESCRICAO: form.descricao,
          IDORIGEM: form.idOrigem ? Number(form.idOrigem) : null,
          valor: Number(form.valor),
          pago: 1
        });

        setRetorno({
          tipo: "sucesso",
          mensagem: "Receita criada com sucesso!"
        });
      }

      if (modo === "alterar") {

        if (form.ativo === "true" || form.ativo === true) {
          setRetorno({
            tipo: "erro",
            mensagem: "Não é possível alterar receitas inativas."
          });
          onClose();
          setLoading(true);
          return;
        }

        if (form.ativo === "false" || form.ativo === false) {
          const confirmado = window.confirm(
            "ATENÇÃO: Esta ação é irreversível. Deseja realmente inativar esta receita?"
          );
          if (!confirmado) {
            setLoading(false);
            return;
          }
        }

        await ReceitasService.inativar(form.idReceita, {
          ATIVO: form.ativo
        });

        setRetorno({
          tipo: "sucesso",
          mensagem: "Receita atualizada com sucesso!"
        });
      }

      onClose();
    } catch {
      onClose();
      setRetorno({
        tipo: "erro",
        mensagem: "Erro ao salvar receita."
      });
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={ReceitaIcon} alt="" className="icon" />
          {modo === "novo" ? "Nova Receita" : "Alterar Receita"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Descrição *</div>
          <select
            name="descricao"
            value={form.descricao}
            disabled={modo === "alterar"}
            onChange={handleChange}
          >
            <option selected value="">Selecione</option>
            <option value="A">Agendamento</option>
            <option value="V">Venda</option>
          </select>
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Origem (ID)</div>
          <input
            type="number"
            name="idOrigem"
            disabled={modo === "alterar"}
            value={form.idOrigem}
            onChange={handleChange}
            placeholder="ID do agendamento ou venda"
          />
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Valor *</div>
          <input
            type="number"
            step="0.01"
            name="valor"
            value={form.valor}
            onChange={handleChange}
          />
        </div>
        {modo === "alterar" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Pago</div>
            <select
              name="pago"
              disabled={modo === "alterar"}
              value={String(form.pago)}
              onChange={handleChange}
            >
              <option selected value="">Selecione</option>
              <option value={true}>Sim</option>
              <option value={false}>Não</option>
            </select>
          </div>
        )}

        {modo === "alterar" && (
          <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Ativo</div>
            <select
              name="ativo"
              value={String(form.ativo)}
              onChange={handleChange}
            >
              <option selected value="">Selecione</option>
              <option value={true}>Sim</option>
              <option value={false}>Não</option>
            </select>
          </div>
        )}

        <div className="Form-Interno-alinhamento-button">
            <button type="submit" disabled={loading} className="Form-Interno-button">
              {loading ? "Salvando..." : "Salvar"}
            </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}